import { ButtonProps, ButtonUI } from './Button';
import { HorizontalLayoutProps, HorizontalLayoutUI } from './HorizontalLayout';
import { IconProps, IconUI } from './IconUI';
import { PageProps, PageUI } from './Page';
import { ResponsiveAppBarProps, ResponsiveAppBarUI } from './ResponsiveAppBar';
import { TextProps, TextUI } from './Text';
import { TextfieldProps, TextfieldUI } from './Textfield';
import { VerticalLayoutProps, VerticalLayoutUI } from './VerticalLayout';
import { DividerProps, DividerUI } from './Divider';
import { SocialButtonProps, SocialButtonUI } from './SocialButton';
import { TextLinkProps, TextLinkUI } from './TextLink';
import { StepperProps, StepperUI } from './Stepper';
import { AutocompleteType, AutocompleteUI } from './Autocomplete';
import { TabsUI, TabsUIType } from './Tabs';
import { ChipProps, ChipUI } from './Chip';
import { AnimateProps, AnimateUI } from './Animate';
import { TextButtonProps, TextButtonUI } from './TextButton';
import { AccordionGroupProps, AccordionGroupUI } from './AccordionGroup';
import { IconButtonProps, IconButtonUI } from './IconButton';
import { GridProps, GridUI } from './Grid';
import { ImageUploadProps, ImageUploadUI } from './ImageUpload';
import { TooltipProps, TooltipUI } from './Tooltip';
import { CarouselProps, CarouselUI } from './Carousel';

type components = {
  Page: React.FC<PageProps>
  VerticalLayout: React.FC<VerticalLayoutProps>
  HorizontalLayout: React.FC<HorizontalLayoutProps>
  Textfield: React.FC<TextfieldProps>
  ResponsiveAppbar: React.FC<ResponsiveAppBarProps>
  Icon: React.FC<IconProps>
  IconButton: React.FC<IconButtonProps>
  Text: React.FC<TextProps>
  TextLink: React.FC<TextLinkProps>
  TextButton: React.FC<TextButtonProps>
  Button: React.FC<ButtonProps>
  Divider: React.FC<DividerProps>
  SocialButton: React.FC<SocialButtonProps>
  Stepper: React.FC<StepperProps>
  Autocomplete: AutocompleteType
  Tabs: TabsUIType
  Chip: React.FC<ChipProps>
  Animate: React.FC<AnimateProps>
  AccordionGroup: React.FC<AccordionGroupProps>
  Grid: React.FC<GridProps>
  ImageUpload: React.FC<ImageUploadProps>
  Tooltip: React.FC<TooltipProps>
  Carousel: React.FC<CarouselProps>
};

const UI: components = {
  Page: PageUI,
  VerticalLayout: VerticalLayoutUI,
  HorizontalLayout: HorizontalLayoutUI,
  Textfield: TextfieldUI,
  TextLink: TextLinkUI,
  TextButton: TextButtonUI,
  ResponsiveAppbar: ResponsiveAppBarUI,
  Icon: IconUI,
  IconButton: IconButtonUI,
  Text: TextUI,
  Button: ButtonUI,
  Divider: DividerUI,
  SocialButton: SocialButtonUI,
  Stepper: StepperUI,
  Autocomplete: AutocompleteUI,
  Tabs: TabsUI,
  Chip: ChipUI,
  Animate: AnimateUI,
  AccordionGroup: AccordionGroupUI,
  Grid: GridUI,
  ImageUpload: ImageUploadUI,
  Tooltip: TooltipUI,
  Carousel: CarouselUI,
};

export default UI;
